import { useState, useEffect, useRef } from 'react';

const useStateWithCallBack = (initialState: any) => {
  const [state, setState] = useState(initialState);
  const callbackRef = useRef<null | ((nextState: any) => void)>(null);

  const setStateCallback = (
    newState: any,
    newCallback: (nextState: any) => void
  ) => {
    callbackRef.current = newCallback;
    setState(newState);
  };

  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(state);
      callbackRef.current = null;
    }
  }, [state]);

  return [state, setStateCallback];
};

export default useStateWithCallBack;
